import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfile } from '../../../models';
import { Store } from '@ngrx/store';

import * as fromUser from '../../../store/fromUser.barrel';
import * as fromMessages from '../../../store/fromMessages.barrel';

import { Observable, Subject, filter, of, takeUntil } from 'rxjs';
import { Guid, toastFactory } from '@tdw/core';
import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.scss']
})
export class ManagementComponent implements OnInit, OnDestroy {
  cachedItems: { key: string, value: any | null, visible: boolean }[] = [];
  userProfile$: Observable<UserProfile | null> = of();

  unsubscribe$ = new Subject();
  active = 1;

  constructor(
    private store: Store<fromUser.State>,
    private modalService: NgbModal,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig
  ) { }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
  }

  ngOnInit(): void {
    this.userProfile$ = this.store.select(fromUser.selectUserProfile);

    this.getLocalStorageItems();
  }

  getLocalStorageItems(): void {
    this.cachedItems = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i) || '';
      if (!!k) {
        let obj = {};
        try {
          obj = JSON.parse(localStorage.getItem(k) || '{}');
        } catch (error) {
          console.log(k, error);
        }

        this.cachedItems.push({
          key: k,
          value: obj,
          visible: false
        });
      };
    }
  }

  removeCacheItem(key: string): void {
    const confirm = this.modalService.open(ConfirmModalComponent, { ...this.config.modalOptions });
    confirm.componentInstance.title = 'Confirm';
    confirm.componentInstance.body = 'Are you sure you want to remove this cache value?';

    confirm.closed.pipe(filter(res => !!res), takeUntil(this.unsubscribe$)).subscribe(val => {
      localStorage.removeItem(key);
      this.getLocalStorageItems();
      this.store.dispatch(fromMessages.addToast({
        toast: toastFactory({
          id: Guid.newGuid(),
          class: 'success',
          title: 'Cache Removed',
          message: 'The cached value has been removed.'
        })
      }));
    });
  }

  toggleVisible(item: { key: string, value: any, visible: boolean }): void {
    item.visible = !item.visible;
  }

  logout(): void {
    this.store.dispatch(fromUser.logout());
  }

}
